import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const Box = styled.div`
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  max-width: 450px;
  color: var(--color-text-primary);
`

const Heading = styled.h1`
  margin-top: 35px;
  margin-right: auto;
  color: var(--color-text-primary);
  display: inline-block;
  padding-bottom: 20px;
  font-size: 42px;
  font-weight: 400;
  line-height: 0.8;
  text-transform: capitalize;
  position: relative;

  &::after {
    content: '';
    width: 90px;
    height: 3px;
    background-color: var(--color-primary);
    position: absolute;
    top: 100%;
    left: 0;
    transform: translateY(-100%);
  }
`

const Message = styled.p`
  margin-top: 35px;
  font-size: 28px;
  color: var(--color-text-secondary);
`

const Button = styled.button`
  background-color: var(--color-primary);
  border: none;
  outline: none;
  border-radius: 20px;
  cursor: pointer;
  height: 32px;
  width: 100%;
  font-size: 14px;
  color: var(--color-bg-main);
  text-transform: uppercase;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--color-secondary);
  }
`

const SignOut = () => {
  const { isAuthenticated, login } = useAuth()

  if (isAuthenticated) {
    return <Redirect to='/' />
  }

  return (
    <Box>
      <header>
        <Button onClick={login}>Login</Button>
      </header>
      <div>
        <Heading>Logged out</Heading>
        <Message>Thanks for working with Caylent!</Message>
      </div>
    </Box>
  )
}

export default SignOut
